import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import authService from '../services/authService';
import { Button, Card, PageHeader, Field, Input } from '../components/ui';

const ChangePassword: React.FC = () => {
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('Die neuen Passwörter stimmen nicht überein');
      return;
    }

    if (formData.newPassword.length < 6) {
      toast.error('Das Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }

    setIsSubmitting(true);

    try {
      await authService.changePassword({
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword
      });
      toast.success('Passwort geändert');
      setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
    } catch (error: any) {
      toast.error(error.message || 'Passwort konnte nicht geändert werden');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl p-6">
      <PageHeader
        title="Passwort ändern"
        subtitle="Aktualisieren Sie das Passwort Ihres Kontos."
      />

      <Card className="max-w-md p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field label="Aktuelles Passwort">
            <Input type="password" required value={formData.oldPassword} onChange={e => setFormData({ ...formData, oldPassword: e.target.value })} disabled={isSubmitting} />
          </Field>
          <Field label="Neues Passwort" hint="Mindestens 6 Zeichen">
            <Input type="password" required minLength={6} value={formData.newPassword} onChange={e => setFormData({ ...formData, newPassword: e.target.value })} disabled={isSubmitting} />
          </Field>
          <Field label="Neues Passwort bestätigen">
            <Input type="password" required minLength={6} value={formData.confirmPassword} onChange={e => setFormData({ ...formData, confirmPassword: e.target.value })} disabled={isSubmitting} />
          </Field>
          <Button type="submit" loading={isSubmitting} className="w-full">
            {isSubmitting ? 'Wird geändert…' : 'Passwort ändern'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default ChangePassword;
